import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    // À chaque changement de path ou de hash
    if (hash) {
      // On enlève le “#” pour récupérer l’ID
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        // Scroll l’élément en douceur
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Optionnel : scroll en haut de la page si pas de hash
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash, pathname]);

  return null; // Ce composant n’affiche rien
}

export default ScrollToHash;
